import { render, staticRenderFns } from "./VerificationForm.vue?vue&type=template&id=f632c05a&"
import script from "./VerificationForm.vue?vue&type=script&lang=js&"
export * from "./VerificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f632c05a')) {
      api.createRecord('f632c05a', component.options)
    } else {
      api.reload('f632c05a', component.options)
    }
    module.hot.accept("./VerificationForm.vue?vue&type=template&id=f632c05a&", function () {
      api.rerender('f632c05a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/eSign/components/VerificationForm.vue"
export default component.exports